import { useChannelStateContext } from "stream-chat-react";

export const useUpdateChannelMetadata = () => {
  const { channel } = useChannelStateContext();

  const updateMetadata = async (newMetadata: Record<string, any>) => {
    if (!channel) return;

    await channel.updatePartial({
      set: {
        ...newMetadata,
      },
    });
  };

  return { updateMetadata };
};
